import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-customer-profile-data',
  templateUrl: './edit-customer-profile-data.component.html',
  styleUrls: ['./edit-customer-profile-data.component.css']
})
export class EditCustomerProfileDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
